export default __webpack_public_path__ + "static/media/chang.png.webp";